import { ToastType } from './toast-types';
import { AppointmentToastStrategy, ClientToastStrategy, PetToastStrategy, ServiceToastStrategy, ServiceVariantToastStrategy, UserToastStrategy, WorkingHoursToastStrategy, TeamMemberToastStrategy, TeamMemberInvitationToastStrategy, LocationToastStrategy, SizeCategoryToastStrategy, CoatTypeToastStrategy, SupportTicketToastStrategy, } from './toast-strategies';
export class ToastStrategyFactory {
    static strategies = {
        [ToastType.Appointment]: new AppointmentToastStrategy(),
        [ToastType.Client]: new ClientToastStrategy(),
        [ToastType.Pet]: new PetToastStrategy(),
        [ToastType.Service]: new ServiceToastStrategy(),
        [ToastType.ServiceVariant]: new ServiceVariantToastStrategy(),
        [ToastType.User]: new UserToastStrategy(),
        [ToastType.WorkingHours]: new WorkingHoursToastStrategy(),
        [ToastType.TeamMember]: new TeamMemberToastStrategy(),
        [ToastType.TeamMemberInvitation]: new TeamMemberInvitationToastStrategy(),
        [ToastType.Location]: new LocationToastStrategy(),
        [ToastType.SizeCategory]: new SizeCategoryToastStrategy(),
        [ToastType.CoatType]: new CoatTypeToastStrategy(),
        [ToastType.SupportTicket]: new SupportTicketToastStrategy(),
    };
    static getStrategy(entityType) {
        return this.strategies[entityType];
    }
}
